import { ChangeDetectorRef, Component, OnInit, Input } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';

import { Payment, Sale } from '../../../models';
import { List } from 'immutable';
import { StripeService } from '../../../services/stripe.service';
import { UserService } from '../../../services/user.service';
import { ClientService } from '../../../services/client.service';
import { StripeManualCardPaymentComponent } from '../stripe-manual-card-payment/stripe-manual-card-payment.component';
import { SalonService } from '../../../services/';
@Component({
  selector: 'smr-sale-payment-stripe',
  templateUrl: './sale-payment-stripe.component.html',
  styleUrls: ['./sale-payment-stripe.component.scss'],
})
export class SalePaymentStripeComponent implements OnInit {
  public paymentTypes: List<Payment> = List([]);

  public payment: Payment;

  public readerConnected: boolean = false;

  @Input() disableCashButton: boolean;

  public paymentProcessing: boolean = true;

  public foundReaders: boolean;

  public showPaymentBox: boolean = false;

  public reader;

  public connectPushed: boolean;

  public cardReaderConnectError: boolean;

  public readerConnectSuccessful: boolean;

  public clientHasStripeID: boolean = false;
  public cardInfo: any;

  public hasCardInfo: boolean = false;

  @Input() sale;

  // paymentType: string;
  @Input() dropDownPushed: boolean = false;

  cardReaderPaymentSelected: boolean = false;

  paymentError: boolean = false;

  public accordionValue: string = '';

  constructor(
    private stripeService: StripeService,
    private ref: ChangeDetectorRef,
    public userService: UserService,
    private modalController: ModalController,
    private clientService: ClientService,
    private toastCtrl: ToastController,
    private salonService: SalonService
  ) {
    // this.paymentTypes = Sale.getPaymentTypesWithStripeAccount();
  }

  public async ngOnInit() {
    this.accordionValue = localStorage.getItem('accordionValue')
      ? localStorage.getItem('accordionValue')
      : '';
    this.salonService.getSalonPaymentTypes().subscribe((paymentTypes) => {
      // if (paymentTypes.cash === 1) {
      //   this.paymentTypes = this.paymentTypes.push(new Payment({ type: 1, name: 'Cash', amount: 0 }))
      // }
      if (paymentTypes.debit === 1) {
        this.paymentTypes = this.paymentTypes.push(
          new Payment({ type: 2, name: 'Debit', amount: 0 })
        );
      }
      if (paymentTypes.visa === 1) {
        this.paymentTypes = this.paymentTypes.push(
          new Payment({ type: 3, name: 'Visa', amount: 0 })
        );
      }
      if (paymentTypes.mastercard === 1) {
        this.paymentTypes = this.paymentTypes.push(
          new Payment({ type: 4, name: 'MasterCard', amount: 0 })
        );
      }
      if (paymentTypes.amex === 1) {
        this.paymentTypes = this.paymentTypes.push(
          new Payment({ type: 5, name: 'AMEX', amount: 0 })
        );
      }
      if (paymentTypes.cheque === 1) {
        this.paymentTypes = this.paymentTypes.push(
          new Payment({ type: 6, name: 'Check/Cheque', amount: 0 })
        );
      }
      if (paymentTypes.giftcard === 1) {
        this.paymentTypes = this.paymentTypes.push(
          new Payment({ type: 7, name: 'Giftcard', amount: 0 })
        );
      }
      if (paymentTypes.etransfer === 1) {
        this.paymentTypes = this.paymentTypes.push(
          new Payment({ type: 8, name: 'e-Transfer', amount: 0 })
        );
      }
      if (paymentTypes.discover === 1) {
        this.paymentTypes = this.paymentTypes.push(
          new Payment({ type: 9, name: 'Discover', amount: 0 })
        );
      }
      if (paymentTypes.account === 1) {
        this.paymentTypes = this.paymentTypes.push(
          new Payment({ type: 10, name: 'Account', amount: 0 })
        );
      }
      if (paymentTypes.square === 1) {
        this.paymentTypes = this.paymentTypes.push(
          new Payment({ type: 11, name: 'Square', amount: 0 })
        );
      }
    });
    // const res = await this.stripeService.discoverReaders();
    // if (res.code !== 'reader_not_found') {
    //   console.log('res', res);
    //   if (JSON.parse(localStorage.getItem('cardReader'))) {
    //     this.reader = JSON.parse(localStorage.getItem('cardReader'));
    //   } else {
    //     if (res.discoveredReaders) {
    //       this.reader = res.discoveredReaders[0];
    //       localStorage.setItem('cardReader', JSON.stringify(this.reader));
    //     }
    //   }
    //   console.log('this.reader', this.reader);
    //   const readerConnection = await this.stripeService.getStatus(this.reader);
    //   this.readerConnected = readerConnection === 'connected';

    // }
    this.connectCardReader();

    const client = this.sale.client;
    this.stripeService
      .getClientStripeID({ clientID: client.id })
      .subscribe((clientStripeIDResponse) => {
        this.clientHasStripeID = !!clientStripeIDResponse;
        if (this.clientHasStripeID) {
          // if there is a stripe id then check to see if there is a card on file. They might have deleted the card but still have a stripe id
          this.stripeService
            .getCustomerCardInfo({ clientID: client.id })
            .subscribe({
              next: (cardInfo) => {
                if (cardInfo) {
                  this.cardInfo = cardInfo;
                  this.hasCardInfo = true;
                }
              },
              error: (err) => {},
            });
        }
      });

    this.showPaymentBox = true;
    this.ref.detectChanges();
    if (this.readerConnected && !this.dropDownPushed) {
      await this.startProcessingPayment(this.reader);
    }
  }

  /**
   * Connects to a Stripe card reader.
   * Discovers available readers, selects the first one, and attempts to connect.
   */
  public async connectCardReader() {
    const res = await this.stripeService.discoverReaders();
    this.foundReaders = !(
      res.code === 'reader_not_found' || res.code === 'reader_error'
    );
    if (res.code == 'reader_not_found') {
      // no readers found
      return;
    }
    console.log('card reader response', res);

    if (res.discoveredReaders && res.discoveredReaders.length > 0) {
      for (let i = 0; i < res.discoveredReaders.length; i++) {
        this.reader = res.discoveredReaders[i];
        console.log('Attempting to connect to reader', this.reader);

        this.connectPushed = true;
        this.cardReaderConnectError = false;

        try {
          const connectResponse = await this.stripeService.connectReader(
            this.reader
          );
          if (!connectResponse['error']) {
            console.log('Successfully connected to reader', this.reader);
            localStorage.setItem('cardReader', JSON.stringify(this.reader));
            this.readerConnected = true;
            this.readerConnectSuccessful = true;
            this.ref.detectChanges();
            await this.startProcessingPayment(this.reader);
            return; // Exit the function if connection is successful
          }
        } catch (error) {
          console.log('Failed to connect to reader', this.reader, error);
        }

        // Reset flags for next attempt
        this.connectPushed = false;
        this.cardReaderConnectError = false;
      }

      // If we've reached this point, all connection attempts failed
      console.log('Failed to connect to any reader');
      this.cardReaderConnectError = true;
    } else {
      console.log('No readers discovered');
    }

    this.connectPushed = false;
    this.ref.detectChanges();
  }

  async cardReaderPayment(paymentType: string) {
    this.cardReaderPaymentSelected = true;
    // this.paymentType = paymentType;
    await this.startProcessingPayment(this.reader);
  }

  async retry() {
    this.paymentError = false;
    await this.startProcessingPayment(this.reader);
  }

  public async startProcessingPayment(reader) {
    const country = this.userService.getSalon().getCountry();
    const currency = country.countryName === 'Canada' ? 'cad' : 'usd';
    const amount = Math.round(this.sale.balance * 100);
    // create payment intent
    this.stripeService
      .createPaymentIntentWithReader({ amount: amount, currency })
      .subscribe(async (PI) => {
        // pass the payment intent to the reader to collect the card details
        const paymentIntent = await this.stripeService.collectPaymentMethod(
          reader,
          PI.client_secret
        );
        if (paymentIntent.error) {
          return;
        }

        const paymentIntentRes = await this.stripeService.processPayment(
          paymentIntent,
          reader
        );
        if (paymentIntentRes.error) {
          this.paymentError = true;
          return;
        } else {
          if (paymentIntentRes.isInterac) {
            const amount = paymentIntentRes.amount / 100;
            const cardInfo = paymentIntentRes.paymentMethod.interac_present;
            const type = this.stripeService.stripePaymentType(
              cardInfo.brand,
              cardInfo.funding
            );
            const expDate =
              ('0' + cardInfo.exp_month).slice(-2) +
              '/' +
              (cardInfo.exp_year + '').slice(-2);
            const chargeID = paymentIntentRes.paymentChargeID;
            this.payment = new Payment({
              amount: amount,
              name: '',
              type: type.type,
              intentID: paymentIntentRes.paymentIntentID,
              last4Digits: cardInfo.last4,
              expDate: expDate,
              chargeID: chargeID,
              isInterac: true,
              applicationFee: paymentIntentRes.applicationFee / 100,
            });
            const data = {
              payment: this.payment,
              action: 'save',
              cashRounding: 0,
              cardPayment: true,
              amountDetails: paymentIntentRes.amountDetails,
            };
            this.modalController.dismiss(data);
          } else {
            this.stripeService
              .capturePayment(paymentIntentRes.paymentIntentID)
              .subscribe((paymentRes) => {
                const amount = paymentRes.amount / 100;
                const cardInfo = paymentIntentRes.paymentMethod.card_present;
                const type = this.stripeService.stripePaymentType(
                  cardInfo.brand,
                  cardInfo.funding
                );
                const expDate =
                  ('0' + cardInfo.exp_month).slice(-2) +
                  '/' +
                  (cardInfo.exp_year + '').slice(-2);
                const chargeID = paymentIntentRes.paymentChargeID;
                this.payment = new Payment({
                  amount: amount,
                  name: '',
                  type: type.type,
                  intentID: paymentRes.id,
                  last4Digits: cardInfo.last4,
                  expDate: expDate,
                  chargeID: chargeID,
                  isInterac: false,
                  applicationFee: paymentRes.application_fee_amount / 100,
                });
                const data = {
                  payment: this.payment,
                  action: 'save',
                  cashRounding: 0,
                  cardPayment: true,
                  amountDetails: paymentRes.amount_details,
                };
                this.modalController.dismiss(data);
              });
          }
        }
        // WHY are we capturing paymentIntent here? we've already got the payment I think
        // await this.stripeService.sendPaymentIntentID(paymentRes.paymentIntentID).first().toPromise();
      });
  }

  public async manualCardPayment(manualInput = false) {
    let cardOnFile = false;
    if (this.cardInfo && !manualInput) {
      cardOnFile = this.cardInfo;
    }
    const manualCardModal = await this.modalController.create({
      component: StripeManualCardPaymentComponent,
      componentProps: {
        sale: this.sale,
        cardOnFile: cardOnFile,
      },
    });
    manualCardModal.onDidDismiss().then((data) => {
      let payment = data.data;
      if (payment) {
        this.payment = new Payment(payment);
        this.payment.setAmount(payment.amount);
        const data = {
          payment: this.payment,
          action: 'save',
          cashRounding: 0,
        };
        this.modalController.dismiss(data);
      } else {
        this.modalController.dismiss();
      }
    });
    manualCardModal.present();
  }

  public onDismiss() {
    if (this.readerConnected && !this.dropDownPushed) {
      const id = this.reader.id;
      this.stripeService.cancelReaderAction(this.reader);
    }

    this.modalController.dismiss();
  }

  public onCashSelect() {
    const data = {
      payment: new Payment({ type: 1, name: 'Cash', amount: 0 }),
      action: 'save',
      cashRounding: 0,
      otherPayment: true,
    };
    this.modalController.dismiss(data);
  }

  public onPaymentSelect(payment: Payment) {
    const data = {
      payment: payment,
      action: 'save',
      cashRounding: 0,
      otherPayment: true,
    };
    this.modalController.dismiss(data);
  }

  public changeAccordionValue(event) {
    localStorage.setItem(
      'accordionValue',
      event.detail.value ? event.detail.value : ''
    );
  }
}
